import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "headline"
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = ["onClick"];
import { reactive, ref } from 'vue';
import RateChangeConfirmationModal from './RateChangeConfirmationModal.vue';
import LlTextField from '@/components/LlTextField.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import { storeToRefs } from 'pinia';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
export default {
  __name: 'EditUserRate',
  props: {
    userName: {
      type: String,
      default: 'User'
    },
    existingRates: {
      type: Object,
      default: () => ({
        standard: 0,
        other: []
      })
    },
    rules: {
      type: Array,
      default: () => []
    }
  },
  emits: ['cancel', 'save'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      handleError
    } = useSnackbarHandler();
    const {
      companySettings
    } = storeToRefs(useCompanyStore());
    const zeroRateAlert = ref(null);
    const props = __props;
    const emit = __emit;
    const rates = reactive({
      form: {
        standard: props.existingRates.standard || 0,
        other: props.existingRates.other?.map(rate => ({
          ...rate,
          isNew: false
        }))
      },
      showRateChangeConfirmationModal: false,
      savingRates: false,
      showZeroRateConfirmationModal: false,
      saveWithZeroRate: false
    });
    const ratesForm = ref(null);
    const addNewRate = () => {
      if (!rates.form.other) {
        rates.form.other = [];
      }
      rates.form.other.push({
        label: '',
        amount: '',
        isNew: true
      });
    };
    const removeRate = index => {
      rates.form?.other?.splice(index, 1);
    };
    const confirmRateLabel = rate => {
      if (rate.label) {
        rate.isNew = false;
      }
    };
    const confirmRateChanges = async () => {
      const standardRateInput = rates.form.standard;
      if (!standardRateInput && standardRateInput !== 0 || isNaN(parseFloat(standardRateInput))) {
        handleError('Please enter a valid standard rate to proceed.');
        return;
      }
      for (const rate of rates.form.other || []) {
        if (!rate.label || rate.label.trim() === '') {
          handleError('Rate name cannot be empty.');
          return;
        }
        if (rate.amount === null || rate.amount === undefined || isNaN(parseFloat(rate.amount))) {
          handleError(`Rate amount for "${rate.label}" cannot be empty or invalid.`);
          return;
        }
      }
      const hasChangesToExistingRates = rates.form?.other?.some((rate, index) => {
        if (rate.isNew) return false;
        const existingRate = props.existingRates.other?.[index];
        return existingRate && (rate.label !== existingRate.label || rate.amount !== existingRate.amount);
      });
      const hasDeletedRates = (props.existingRates.other?.length || 0) !== (rates.form.other?.filter(rate => !rate.isNew).length || 0);
      const hasStandardRateChanged = parseFloat(props.existingRates.standard) !== parseFloat(standardRateInput);
      const standardRate = parseFloat(standardRateInput);
      const zeroRatesExist = parseFloat(standardRateInput) === 0 || rates.form?.other?.some(rate => parseFloat(rate.amount) === 0);
      if (zeroRatesExist && !rates.saveWithZeroRate) {
        triggerZeroRateConfirmation();
        return;
      }
      if (hasStandardRateChanged || hasChangesToExistingRates || hasDeletedRates) {
        rates.showRateChangeConfirmationModal = true;
        return;
      }
      saveRates({
        updateMatters: false,
        updateEntries: false
      });
    };
    const triggerZeroRateConfirmation = () => {
      zeroRateAlert.value.open().then(result => {
        if (result) {
          rates.savingRates = true;
          rates.saveWithZeroRate = true;
          confirmRateChanges();
        }
      });
    };
    const saveRates = async rateOptions => {
      rates.showRateChangeConfirmationModal = false;
      emit('save', {
        rateOptions: {
          updateMatters: rateOptions.updateMatters,
          updateEntries: rateOptions.updateEntries
        },
        rates: {
          standard: rates.form.standard,
          other: rates.form.other?.map(({
            isNew,
            ...rate
          }) => rate)
        }
      });
      closeModal();
    };
    const closeModal = () => {
      emit('update:modal', false);
    };
    return (_ctx, _cache) => {
      const _component_v_dialog = _resolveComponent("v-dialog");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_col = _resolveComponent("v-col");
      const _component_v_row = _resolveComponent("v-row");
      const _component_v_form = _resolveComponent("v-form");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_spacer = _resolveComponent("v-spacer");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      return _openBlock(), _createBlock(_component_v_card, null, {
        default: _withCtx(() => [_createVNode(LlConfirmationDialog, {
          showWarningIcon: true,
          ref_key: "zeroRateAlert",
          ref: zeroRateAlert,
          title: "",
          "confirm-text": "Save Anyway",
          "toggle-text": "Cancel",
          message: `Note: $0 default rates are not recommended. A user's default rate will be assigned unless another rate is specified. Therefore, a $0 default rate can result in time entries becoming ready to bill or even sent in invoices with $0 rates.`
        }, null, 512), _createVNode(_component_v_dialog, {
          modelValue: rates.showRateChangeConfirmationModal,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => rates.showRateChangeConfirmationModal = $event),
          width: "400"
        }, {
          default: _withCtx(() => [_createVNode(RateChangeConfirmationModal, {
            onSave: saveRates,
            onCancel: _cache[0] || (_cache[0] = $event => rates.showRateChangeConfirmationModal = false)
          })]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_v_card_title, {
          class: "border-none"
        }, {
          append: _withCtx(() => [_createVNode(_component_v_icon, {
            onClick: _cache[2] || (_cache[2] = $event => _ctx.handleCloseButton())
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("mdi-close", -1)]))]),
            _: 1
          })]),
          default: _withCtx(() => [_createElementVNode("span", _hoisted_1, "Rates for " + _toDisplayString(__props.userName), 1)]),
          _: 1
        }), _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [_createVNode(_component_v_form, {
            ref_key: "ratesForm",
            ref: ratesForm,
            class: "mb-0"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_row, {
              class: "mb-0 align-center"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                cols: "5",
                class: "mb-5"
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createElementVNode("span", null, "STANDARD", -1)]))]),
                _: 1
              }), _createVNode(_component_v_col, {
                cols: "4"
              }, {
                default: _withCtx(() => [_createVNode(LlTextField, {
                  modelValue: rates.form.standard,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => rates.form.standard = $event),
                  step: _unref(companySettings).timeEntryIncrement || 0.1,
                  label: "",
                  required: "",
                  type: "number",
                  placeholder: "Amount",
                  hideDetails: false,
                  rules: __props.rules
                }, null, 8, ["modelValue", "step", "rules"])]),
                _: 1
              })]),
              _: 1
            }), rates.form.other?.length ? (_openBlock(true), _createElementBlock(_Fragment, {
              key: 0
            }, _renderList(rates.form.other, (rate, index) => {
              return _openBlock(), _createBlock(_component_v_row, {
                key: index,
                class: "mb-2 align-center"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_col, {
                  cols: "5"
                }, {
                  default: _withCtx(() => [rate.isNew ? (_openBlock(), _createBlock(LlTextField, {
                    key: 0,
                    modelValue: rate.label,
                    "onUpdate:modelValue": $event => rate.label = $event,
                    label: "",
                    dense: "",
                    outlined: "",
                    type: "text",
                    placeholder: "New rate name",
                    rules: __props.rules,
                    onBlur: $event => confirmRateLabel(rate)
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "rules", "onBlur"])) : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(rate.label.toUpperCase()), 1))]),
                  _: 2
                }, 1024), _createVNode(_component_v_col, {
                  cols: "4"
                }, {
                  default: _withCtx(() => [_createVNode(LlTextField, {
                    modelValue: rate.amount,
                    "onUpdate:modelValue": $event => rate.amount = $event,
                    label: "",
                    dense: "",
                    outlined: "",
                    type: "number",
                    placeholder: "Rate",
                    step: _unref(companySettings).timeEntryIncrement || 0.1,
                    rules: __props.rules
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "step", "rules"])]),
                  _: 2
                }, 1024), _createVNode(_component_v_col, {
                  cols: "3"
                }, {
                  default: _withCtx(() => [_createElementVNode("a", {
                    class: "cursor-pointer",
                    onClick: $event => removeRate(index)
                  }, "Remove", 8, _hoisted_3)]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1024);
            }), 128)) : _createCommentVNode("", true), _createElementVNode("a", {
              class: "cursor-pointer",
              onClick: addNewRate
            }, "Add new rate")]),
            _: 1
          }, 512)]),
          _: 1
        }), _createVNode(_component_v_card_actions, null, {
          default: _withCtx(() => [_createVNode(LlSecondaryButton, {
            onClick: _cache[4] || (_cache[4] = $event => emit('cancel'))
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("Cancel", -1)]))]),
            _: 1
          }), _createVNode(_component_v_spacer), _createVNode(LlSecondaryButton, {
            color: "primary",
            onClick: confirmRateChanges,
            type: "submit",
            isSaving: rates.savingRates,
            disabled: rates.savingRates
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("Save Rates", -1)]))]),
            _: 1
          }, 8, ["isSaving", "disabled"])]),
          _: 1
        })]),
        _: 1
      });
    };
  }
};